import EduTemplate from 'components/standard/mudmanage/Edutemplate'

function Edutemplate() {
  return <EduTemplate />
}

export default Edutemplate;
